module.exports = __webpack_public_path__ + "assets/c7a212147f3cd08ad7fd012ca6f5fbaf.png";